
export enum MonitorStatusTypes {
  Ok = 1,
  Error = 2,
}
